export default function InfoIcon({ color = '#A27E8A' }: { color?: string }) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_7758_2288)">
        <path
          d="M6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5Z"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.625 5.625C5.72446 5.625 5.81984 5.66451 5.89016 5.73484C5.96049 5.80516 6 5.90054 6 6V7.875C6 7.97446 6.03951 8.06984 6.10983 8.14017C6.18016 8.21049 6.27554 8.25 6.375 8.25"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 4.5C6.41421 4.5 6.75 4.16421 6.75 3.75C6.75 3.33579 6.41421 3 6 3C5.58579 3 5.25 3.33579 5.25 3.75C5.25 4.16421 5.58579 4.5 6 4.5Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_7758_2288">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
